<template>
      <PageBase title="Ambitiethema installatiearm bouwen" description="" :valid="valid" @show-error="showError" :right-button-classes="'mr-12'" :show-right-margin="false">
        <div class="flex gap-4 xl:-mt-6 mr-12">
          <div class="flex-1"></div>
            <div class="text-base -mt-2 text-right w-64 xl:w-auto xl:mt-2">Dit ambitiethema meenemen in de aanvraag?</div>

            <JaNeeToggleButton v-model="store.registrationData.prioriteringsThemas.installatiearm" />

        </div>
        <div class="flex flex-col gap-3 max-h-[calc(100vh-270px)] overflow-y-auto overflow-x-hidden pr-12">

          <div class="flex flex-col-reverse lg:flex-row gap-5">
            <div class="flex-1">
              <img class="object-contain" src="/src/assets/Installatie_bouwen.png" />
            </div>
          <div class="flex-1 flex flex-col gap-4">
            <div class="text-sm italic">Het generieke Programma van Eisen (PvE) voor scholen biedt een
  flexibel raamwerk dat eenvoudig kan worden afgestemd op de
  specifieke wensen van gemeenten en schoolbesturen. Dit gebeurt
  aan de hand van verschillende ambitie-opties, zoals de optie voor
  installatiearm bouwen. Deze keuze stelt opdrachtgevers in staat om te
  kiezen voor een meer natuurlijke bouwbenadering, wat resulteert in een gebouw met minder technische installaties.
            </div>

            <div class="text-sm">Door het gebouw zodanig te ontwerpen dat de bouwfysische
  eigenschappen optimaal bijdragen aan een verminderd
  energieverbruik in zowel de zomer als de winter, kan een ontwerp
  worden gerealiseerd dat minimale installatiebehoeften heeft. Dit
  duurzame ontwerp maakt gebruik van passieve strategieën zoals
  isolatie, thermische massa en zonwering, evenals het gebruik van
  overstekken en begroeiing om de zoninstraling in de zomer te
  verminderen. Daarnaast kunnen verblijfsruimten strategisch worden
  gepositioneerd en ontworpen met veel beglazing op de west-,
  noord- en oostgevels. Dit zorgt ervoor dat deze ruimtes profiteren
  van natuurlijk licht zonder overmatige warmtewinst in de zomer.
  Deze ontwerpkeuzes dragen bij aan een comfortabel binnenklimaat
  en verminderen de noodzaak voor kunstmatige verlichting en
  klimaatbeheersing, wat bijdraagt aan een lager energieverbruik en
  een kleinere ecologische voetafdruk.</div>

            <div class="text-sm">Gezonde scholen met een goed binnenklimaat is speerpunt van
  het programma en een vereiste voor toekomstige projecten. Echter
  worden de installatieconcepten vaak uitgelegd op piekmomenten
  in de zomer- en winter. Dit zorgt ervoor dat er uitgebreide en
  complexe installatiesystemen nodig zijn die leiden tot hoge
  energie- en onderhoudskosten. Het projectteam gaat onderzoeken
  hoe de eisen voor binnenklimaat kunnen worden geoptimaliseerd
  door meer gebruik van natuurlijke en passieve principes. Bij een
  installatiearm ontwerp kan een extra overschrijding van de Frisse
  Scholen klasse B toelaatbaar zijn. Deze flexibiliteit kan worden
  gecompenseerd door passieve koelingsstrategieën zoals natuurlijke
  ventilatie, nachtventilatie en thermische massa. Hierdoor blijft het
  binnenklimaat comfortabel zonder energie-intensieve koelsystemen,
  wat bijdraagt aan een duurzamer en energie-efficiënter ontwerp.</div>

            <div class="text-sm">In de 0.5 versie van het generiek PvE is nog géén invulling gegeven
  aan deze knop omdat nader onderzoek zal worden gedaan. Hierbij
  zullen een aantal opgeleverde projecten worden geanalyseerd
  die op natuurlijke principe met alleen noodzakelijke installatie zijn
  gerealiseerd. Bij de analyse zullen de eisen worden vergeleken met
  de energieprestaties en het welzijn van de gebruikers.</div>
          </div>
          </div>


        </div>
      </PageBase>
</template>

<script setup lang="ts">
import PageBase from '@/views/pages/PageBase.vue'
import { useRegistrationStore } from '@/stores/registration'
import { ref } from 'vue';
import JaNeeToggleButton from '@/components/JaNeeToggleButton.vue';
const errorsShown = ref(false)
const valid = ref(true)

const store = useRegistrationStore()

function showError() {
  errorsShown.value = true
}
</script>
